import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function UserAvatar() {
  const { user, isLoading, isAuthenticated } = useAuth();

  if (isLoading || (isAuthenticated && !user)) {
    return (
      <div className="flex items-center gap-2">
        <div className="h-3 w-24 rounded-full bg-gray-200 animate-pulse" />
        <div className="w-8 h-8 rounded-full bg-gray-200 animate-pulse" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="flex items-center gap-2">
        <div className="h-3 w-24 rounded-full bg-gray-200 animate-pulse" />
        <div className="w-8 h-8 rounded-full bg-gray-200 animate-pulse" />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-gray-600">{user.displayName}</span>
      <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center overflow-hidden">
        {user.photoUrl ? (
          <img 
            src={user.photoUrl} 
            alt={user.displayName} 
            className="w-full h-full object-cover"
          />
        ) : (
          <svg className="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
          </svg>
        )}
      </div>
    </div>
  );
}
